/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Iconik_Publish_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Project failed to publish with error: {error}" |
*
* @param {Iconik_Publish_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_failed_toast = /** @type {((inputs: Iconik_Publish_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de publication du projet : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Das Projekt konnte mit folgendem Fehler nicht veröffentlicht werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`La pubblicazione del progetto non è riuscita a causa dell'errore: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Проект не был опубликован с ошибкой: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`El proyecto no se pudo publicar con el error: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`项目发布失败，错误信息：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`プロジェクトの公開に失敗しました。エラー: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`प्रोजेक्ट ${i?.error} त्रुटि के साथ प्रकाशित होने में विफल रहा।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`O projeto não pôde ser publicado devido ao erro: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Project failed to publish with error: ${i?.error}`)
});